import classNames from 'classnames';
import css from './global-search.module.scss';
import { ReactComponent as Education } from 'src/assets/services/education.svg';
import { useNavigate } from 'react-router-dom';
import Cards from 'src/components/form/search/cards/cards';
import Course from '../courses/course';
import { CourseItem } from '../courses/types';
import PaginatedFooter from 'src/components/paginated-footer/paginated-footer';
import { EDUCATION_COURSES } from 'src/constants/routes';

function CourseBlock({
  courses,
  search
}: Readonly<{ courses: { totalCount: number; items: CourseItem[] }; search: string }>) {
  const navigate = useNavigate();
  return (
    <div className={css.searchResultsGroup}>
      <div className={classNames(css.header, css.education)}>
        <div className={css.icon}>
          <Education />
        </div>
        <p>Освіта: Каталог курсів'</p>
      </div>
      <Cards className={css.courses}>
        {courses.items.map((course) => (
          <Course key={course.id} course={course} />
        ))}
      </Cards>
      {courses.totalCount > 3 && (
        <PaginatedFooter
          caption={`Дивитися всі: ${courses.totalCount}`}
          onClick={() => navigate(EDUCATION_COURSES.path, { state: { search: search } })}
        />
      )}
    </div>
  );
}

export default CourseBlock;
